//angular
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

//local
import { SecurityConfig } from '@app/core';
import { ApiConstants, HttpParamHelper, HttpResult, PollyHttpHelper } from '@app/shared';
import { ProjectPropertyDto, CreateProjectRequest, UpdateProjectRequest, ExportPackageRequest } from '@app/catalog';

// The subset of fields shared by CreateProjectRequest and UpdateProjectRequest, both sent as multipart/form-data.
interface ProjectFormFields
{
    programId: string;
    description: string;
    name: string;
    cap: string;
    spa: File | null;
}

@Injectable({
    providedIn: 'root'
})
export class ProjectHttpService
{
    constructor(
      private http: HttpClient, 
      private applicationConfig: SecurityConfig) {    
    }


    public getProperties(projectId: string, programId: string): HttpResult<ProjectPropertyDto> 
    {
      const queryParams: Record<string, string | undefined> = {
        programId
      }
    
      const params = HttpParamHelper.toHttpParams(queryParams);
      let serviceUri = `${this.applicationConfig.applicationUri}/v2/catalog/project/${projectId}`;
            
      console.log(`GET: ${serviceUri}`); 
      
      return PollyHttpHelper.Invoke('GET', () => this.http.get<ProjectPropertyDto>(serviceUri, { headers: ApiConstants.DefaultHeaders, params }));
    }

    public create(request: CreateProjectRequest): HttpResult<Object>
    {
      let serviceUri = `${this.applicationConfig.applicationUri}/v2/project/catalog`;

      console.log(`POST: ${serviceUri}`);
      console.log(request);

      return PollyHttpHelper.Invoke('POST', () => this.http.post<Object>(serviceUri, this.toFormData(request), { headers: this.multipartHeaders() }));
    }

    // Content-Type is intentionally omitted so the browser sets the multipart boundary itself.
    private multipartHeaders()
    {
      return { 'Accept': ApiConstants.DefaultHeaders['Accept'] };
    }

    private toFormData(request: ProjectFormFields): FormData
    {
      let formData = new FormData();
      formData.append('programId', request.programId ?? '');
      formData.append('description', request.description ?? '');
      formData.append('name', request.name ?? '');
      formData.append('cap', request.cap ?? '');

      if (request.spa) {
        formData.append('spa', request.spa);
      }

      return formData;
    }

    public update(projectId: string, request: UpdateProjectRequest): HttpResult<Object>
    {
      let serviceUri = `${this.applicationConfig.applicationUri}/v2/project/${projectId}`;

      console.log(`PUT: ${serviceUri}`);
      console.log(request);

      return PollyHttpHelper.Invoke('PUT', () => this.http.put<Object>(serviceUri, this.toFormData(request), { headers: this.multipartHeaders() }));
    }

    public exportPackage(request: ExportPackageRequest): HttpResult<Object> 
    {      
      let serviceUri = `${this.applicationConfig.applicationUri}/v2/exportpackage`;
            
      console.log(`POST: ${serviceUri}`); 
      console.log(request);
            
      return PollyHttpHelper.Invoke('POST', () => this.http.post<Object>(serviceUri, request, { headers: ApiConstants.DefaultHeaders }));
    }
}